module.exports = __webpack_public_path__ + "static/media/banner_home_big5-min.d11d8caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/banner_home_big5-min.jpg
// module id = 633
// module chunks = 0